import React, { useState, useEffect } from 'react';
import StoreRulesStyled from './StoreRulesStyled';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  useTheme,
  Button,
  FormLabel,
  IconButton,
  Box,
  FormHelperText,
} from '@material-ui/core';
import DataTableNativeML from '@/components/DataTableNativeML';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import { useForm, Controller } from 'react-hook-form';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import { useIntl } from 'umi';
import { CheckBoxFieldCom, RadioFieldCom } from '@/components/FormType';
import { channelMapList } from '@/constants';

export default (props) => {
  const theme = useTheme();
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    isAllStore,
    setIsAllStore,
    storesChooseItemShowData,
    setStoresChooseItemShowData,
    opt,
    setStoresChooseDataId,
    setStoresChooseItemData,
    setStoresChooseItemShowIdData,
    storesChooseDataId,
    storesChooseItemData,
    storesChooseItemShowIdData,
    handleAddStore,
    errors,
    getValues,
    setValue,
    control,
    watch,
    orderChannelConditions,
    orderChannelIsLimit,
  } = props;
  const {} = useForm({
    defaultValues: {
      orderChannelIsLimit: '0',
      orderChannelConditions: [],
    },
  });
  const regionList = channelMapList.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  useEffect(() => {
    setValue('orderChannelConditions', orderChannelConditions);
    setValue('orderChannelIsLimit', String(orderChannelIsLimit));
  }, [orderChannelConditions, orderChannelIsLimit]);
  useEffect(() => {
    if (storesChooseItemShowData?.length > 0) {
      const defaultIds = storesChooseItemShowData.map((item) => item.id);
      setStoresChooseItemShowIdData(defaultIds);
    }
  }, [storesChooseItemShowData]);

  useEffect(() => {
    // 点击全部门店、
    if (isAllStore === 'IS_ALL_STORE' || isAllStore === 'POSITIVE_STORE') {
      setStoresChooseItemShowData([]);
      setStoresChooseItemShowIdData([]);
    }
  }, [isAllStore]);

  const [storePage, setStorePage] = useState(1);

  // 门店的分页
  const handleStorePrevious = () => {
    storePage > 1 && setStorePage(storePage - 1);
  };
  const handleStoreDown = () => {
    storesChooseItemShowData.length - storePage * 10 > 0 &&
      setStorePage(storePage + 1);
  };

  //计算总页数
  const initPageSize = (num) => {
    return Math.ceil(num / 10);
  };

  //计算当前分页的列表
  const initDataTables = (list, page) => {
    const newList = list ?? [];
    const startPage = page > 1 ? (page - 1) * 10 : 0;
    const endPage = 10;
    const data = [...newList].splice(startPage, endPage);
    return data;
  };

  //点击删除已经选中的门店
  const handleDeleteStores = (id) => {
    const prevStoresChooseDataId = storesChooseDataId.filter((item) => {
      return item !== id;
    });
    const prevStoresChooseItemData = storesChooseItemData.filter((item) => {
      return item.id !== id;
    });
    const prevStoresChooseItemShowData = storesChooseItemShowData.filter(
      (item) => {
        return item.id !== id;
      },
    );
    const prevStoresChooseItemShowIdData = storesChooseItemShowIdData.filter(
      (item) => {
        return item !== id;
      },
    );
    setStoresChooseDataId(prevStoresChooseDataId);
    setStoresChooseItemData(prevStoresChooseItemData);
    setStoresChooseItemShowData(prevStoresChooseItemShowData);
    setStoresChooseItemShowIdData(prevStoresChooseItemShowIdData);
    // setValue(
    //   'stores',
    //   (storesTypeChooseState ?? deStoresTypeChooseState) === '0'
    //     ? JSON.stringify(prevStoresChooseItemShowData)
    //     : '',
    // );
  };

  const showColumns = [
    {
      // title: '门店Code',
      title: formatMessage({
        id: 'marketing.scene.holiday.c11.lbl01',
      }),
      id: 'storeNo',
      align: 'center',
      width: 150,
    },
    {
      // title: '门店名称',
      title: formatMessage({
        id: 'marketing.scene.holiday.c11.lbl02',
      }),
      id: 'name',
      align: 'center',
      width: 460,
    },
    {
      // title: '操作',
      title: formatMessage({
        id: 'marketing.scene.c01.lbl06',
      }),
      align: 'center',
      id: 'details',
      width: 100,
      render: (items) => {
        return (
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              lineHeight: '64px',
            }}
          >
            <div
              style={{
                display: 'flex',
                lineHeight: '64px',
                cursor: 'pointer',
              }}
            >
              <ButtonTip title="删除">
                <IconButton>
                  <DeleteForeverOutlinedIcon
                    style={{
                      fontSize: '20px',
                      color: opt === 'detail' ? 'darkgray' : '#525CA3',
                    }}
                    onClick={() =>
                      opt !== 'detail' && handleDeleteStores(items.id)
                    }
                    disabled={opt === 'detail'}
                  ></DeleteForeverOutlinedIcon>
                </IconButton>
              </ButtonTip>
            </div>
          </div>
        );
      },
    },
  ];

  const handleAddStoreOpen = () => {
    // 点击打开modal
    handleAddStore();
  };

  const campaignAreaLimitRegConsume = [
    { value: '0', label: '不限制' },
    { value: '1', label: '限制' },
  ];
  return (
    <StoreRulesStyled theme={theme}>
      <Box className="campaign_area">订单渠道：</Box>
      {/* 消费区域 */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <RadioFieldCom
          name="orderChannelIsLimit"
          control={control}
          defaultValue="0"
          disabled={opt === 'detail'}
          rules={{
            validate: {
              hasLimitRegConsume: () => {
                if (watch('orderChannelIsLimit') === '1') {
                  return getValues('orderChannelConditions')?.length > 0;
                }
                return true;
              },
            },
          }}
          typeList={campaignAreaLimitRegConsume}
        />
        <Box className="mention">
          若勾选则仅在选中的销售渠道下单的会员才有机会获得权益
        </Box>
      </Box>
      <FormHelperText
        error={Boolean(errors.orderChannelIsLimit)}
        sx={{ fontSize: '12px' }}
      >
        {Boolean(errors.orderChannelIsLimit?.type === 'hasLimitRegConsume') &&
          '请选择活动限制区域'}
      </FormHelperText>
      <Box
        width="100%"
        mt={2}
        sx={{
          display: watch('orderChannelIsLimit') === '1' ? 'flex' : 'none',
          alignItems: 'center',
        }}
      >
        <Box className="area">渠道：</Box>
        <CheckBoxFieldCom
          disabled={opt === 'detail'}
          row={true}
          name="orderChannelConditions"
          control={control}
          checkedBoxList={regionList}
          getValues={getValues}
          setValue={setValue}
        />
      </Box>
      <FormLabel component="legend" className="basic-cycle">
        <span className="label-require">*</span>
        {formatMessage({ id: 'marketing.scene.holiday.n08.lbl01' })}
      </FormLabel>
      <Box width="100%" mt={7.5}>
        <Box display="flex">
          <Controller
            render={(pr) => (
              <RadioGroup
                aria-label="couponUsingThreshold"
                onChange={(e) => {
                  setIsAllStore(e.target.value);
                  // deStoresTypeChooseState = undefined;
                  return pr.onChange(e.target.value);
                }}
                className="checkbox-radio-disabled-color store-wrap"
                value={isAllStore}
                // value={
                //   storesTypeChooseState ?? deStoresTypeChooseState
                // }
                disabled={opt === 'detail'}
              >
                <Box display="flex" gridGap="0 86px">
                  <Box display="flex" mr={11}>
                    <FormControlLabel
                      variant="standard"
                      value={'IS_ALL_STORE'}
                      control={<Radio disabled={opt === 'detail'} />}
                      label={
                        <Box color="#000">
                          {formatMessage({
                            id: 'marketing.scene.holiday.n08.rdo02',
                          })}
                        </Box>
                      }
                    />
                  </Box>
                  {/* 仅正价店 */}
                  <Box mr={11}>
                    <FormControlLabel
                      variant="standard"
                      value={'POSITIVE_STORE'}
                      control={<Radio disabled={opt === 'detail'} />}
                      label={
                        <Box color="#000">
                          {formatMessage({
                            id: 'marketing.scene.holiday.n08.rdo03',
                          })}
                        </Box>
                      }
                    />
                  </Box>
                  <Box mr={3}>
                    <FormControlLabel
                      variant="standard"
                      value={'ASSIGN_STORE'}
                      control={<Radio disabled={opt === 'detail'} />}
                      label={
                        <Box color="#000">
                          {formatMessage({
                            id: 'marketing.scene.holiday.n08.rdo04',
                          })}
                        </Box>
                      }
                    />
                  </Box>
                </Box>
              </RadioGroup>
            )}
            control={control}
            name="isAllStore"
            rules={{
              validate: () => {
                // if (
                //   getValues('isAllStore') === '0' &&
                //   storesChooseItemShowData.length === 0
                // ) {
                //   return false;
                // }
                // return true;
              },
            }}
          />
          {isAllStore === 'ASSIGN_STORE' && (
            <Button
              // disabled={
              //   !(
              //     storesTypeChooseState === '0' ||
              //     deStoresTypeChooseState === '0'
              //   )
              // }
              variant="contained"
              onClick={handleAddStoreOpen}
              // title="Submit"
              className="checkbox-radio-disabled-color stores-setting-button"
              disabled={opt === 'detail'}
            >
              {/* 添加 */}
              {formatMessage({ id: 'marketing.scene.holiday.n05.btn01' })}
            </Button>
          )}
        </Box>
        <Box className="init-error-style">
          {/* {errors.isAllStore && '请添加适用门店'} */}
        </Box>
        {isAllStore === 'ASSIGN_STORE' && (
          <Box width="758px">
            <DataTableNativeML
              pageButton={false}
              columns={showColumns}
              // data={storesChooseItemShowData}
              columnKey="id"
              total={100}
              data={initDataTables(storesChooseItemShowData, storePage)}
              devicesMinWidth="auto"
            />
            {storesChooseItemShowData?.length > 0 && (
              <Box display="flex" justifyContent="flex-end" gap="0 12px" mt={1}>
                <Box
                  onClick={handleStorePrevious}
                  sx={{
                    cursor: 'pointer',
                    color: storePage === 1 ? '#C9C9C9' : 'inherit',
                  }}
                >
                  上一页
                </Box>
                <Box>第{storePage}页</Box>
                <Box
                  onClick={handleStoreDown}
                  sx={{
                    cursor: 'pointer',
                    color:
                      storePage * 10 >= storesChooseItemShowData?.length
                        ? '#C9C9C9'
                        : 'inherit',
                  }}
                >
                  下一页
                </Box>
                <Box>
                  共{initPageSize(storesChooseItemShowData?.length || 0)}页
                </Box>
              </Box>
            )}
          </Box>
        )}
        {/* {(storesTypeChooseState === '0' ||
                      deStoresTypeChooseState === '0') && (
                      <Box width="758px">
                        <DataTableNativeML
                          pageButton={false}
                          columns={showColumns}
                          data={storesChooseItemShowData}
                          columnKey="id"
                          total={100}
                          devicesMinWidth="auto"
                        />
                      </Box>
                    )} */}
        {/* 选择门店 */}
        {/* <DialogML
          open={dialogStatus}
          title={labelCom}
          minheightinit={480}
          minwidthinit={800}
          describe={storesContent()}
          handleClose={onCloseDialog}
          specilaAlgorithmLabValue={'ok'}
        /> */}
      </Box>
    </StoreRulesStyled>
  );
};
